import { render, staticRenderFns } from "./mescroll-demo.vue?vue&type=template&id=01d3c75c&scoped=true"
import script from "./mescroll-demo.vue?vue&type=script&lang=js"
export * from "./mescroll-demo.vue?vue&type=script&lang=js"
import style0 from "./mescroll-demo.vue?vue&type=style&index=0&id=01d3c75c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3c75c",
  null
  
)

export default component.exports